import React from 'react';
import { SshKey } from '~/lib/ApiModel';
import { MultiSelectButtonList, MultiSelectButtonItem, MultiSelectButtonAction } from '~/components/SelectButtonList';

type SshKeySelectorProps = {
    sshKeys: SshKey[];
    selectedKeyIds: number[];
    onToggleSelectedId: (keyId: number) => unknown;
    onAddKeyClicked?: () => void;
};

export default class SshKeySelector extends React.Component<SshKeySelectorProps> {
    render() {
        const { sshKeys, selectedKeyIds, onToggleSelectedId = () => {}, onAddKeyClicked } = this.props;
        return (
            <MultiSelectButtonList legend="SSH keys">
                {sshKeys.map((k) => {
                    const selected = !!selectedKeyIds.find((id) => id === k.id);
                    return (
                        <MultiSelectButtonItem
                            key={k.id}
                            isSelected={selected}
                            onSelect={() => onToggleSelectedId(k.id)}
                        >
                            {selected && <i className="icon ion-md-checkmark"></i>} {k.name}
                        </MultiSelectButtonItem>
                    );
                })}
                <MultiSelectButtonAction key="add-key" onSelect={() => onAddKeyClicked?.()}>
                    <i className="icon ion-md-add"></i> Add SSH Key
                </MultiSelectButtonAction>
            </MultiSelectButtonList>
        );
    }
}
